import TotalToPay from '../../components/TotalToPay'
import TextInformation from '../../components/TextInformation'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Divider,
  Link,
  Stack,
  styled,
  Typography,
  useMediaQuery,
  useTheme,
  Grid,
  DialogTitle,
  DialogActions
} from '@mui/material'
import DetailSchedules from '../../components/DetailSchedules'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { cartDataInit, colegialDataInit, formDataInit } from '../../utils/data'
import Progress from '../../components/Progress'
import { packPayment } from '../../utils/packPayment'
import { truncateTarjeta } from '../../utils/commons'
import { HighlightOff } from '@mui/icons-material'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css/navigation'
import 'swiper/css'
import { Navigation, Mousewheel } from 'swiper'
import Lightbox from 'yet-another-react-lightbox'
import { useApp } from '../../hooks/useApp'
import { useTranslation } from 'react-i18next'
import '../../i18n'
import { useCreateBooking, usePayment, useUploadProof } from '../../queries/useBookingQueries'
import { setFormDataKey, useFormData, useTiloPayPaymentData } from '../../queries/userGlobalQueries'
import { queryClient } from '../../queries/config'
import React from 'react'
import UrlBase from '../../urls/Urls'

const BoxStyled = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: ' 1fr 1fr',
  alignItems: 'center',
  width: '100%',
  marginTop: 25,
  gap: 8,
  marginBottom: 10
}))

const LightboxStyled = styled(Lightbox)(({ theme }) => ({
  '& .yarl__container': {
    backgroundColor: '#000000b0'
  },
  '& img': {
    width: '600px !important',
    height: '400px !important',
    maxWidth: '600px !important',
    maxHeight: '400px !important'
  }
}))

const Confirmation = ({
  handleBack,
  cartData,
  colegial,
  setActiveStep,
  setCartData,
  setColegial,
  setHiddenCart,
  payOrder,
  currency,
  areasData
}: any) => {
  const { t } = useTranslation()
  const { setReserved, iDCompany, setErrorMsg } = useApp()
  const [response, setResponse] = useState<any>(undefined)
  const [resultGDataCollector, setResultGDataCollector] = useState<any>(undefined)
  const [responsePayment, setResponsePayment] = useState<any>(undefined)
  const [openModal, setOpenModal] = useState<boolean>(false)
  const [paymentWindow, setPaymentWindow] = useState<Window | null>(null)
  const theme = useTheme()
  const isXs = useMediaQuery(theme.breakpoints.down('sm'))

  const { data: formData } = useFormData()

  const [urlImg, setUrlImg] = useState<string[] | undefined>(
    formData.photoGallery ? formData.photoGallery : undefined
  )
  const [open, setOpenLightbox] = useState<boolean>(false)
  const [indexImg, setIndexImg] = useState<number>(0)
  const type = formData.areaType
  const { data: tiloPayPaymentData } = useTiloPayPaymentData()
  const [confirmModal, setConfirmModal] = React.useState(false)
  const [proofFileError, setProofFileError] = useState(false)

  // Mutations
  const createBookingMutation = useCreateBooking()
  const paymentMutation = usePayment()
  const uploadProofMutation = useUploadProof()

  useEffect(() => {
    document.documentElement.scrollTop = 0
    // @ts-ignore
    const GDataCollector = window.GDataCollector
    GDataCollector.init('sand', null, function (params: any) {
      params.setupCallback({
        'collect-end': function (params: any) {
          console.log('SessionId', params.MercSessId)
          setResultGDataCollector(params.MercSessId)
        },
        'collect-begin': function () {
          console.log('collection has started')
        }
      })
      params.collectData()
    })
  }, [])

  const apiReservation = async (reference?: string) => {
    var urlProof = ''

    const dataToSend: any = {
      name: formData.isColegial ? colegial.name : formData.userName,
      lastName: formData.isColegial ? '' : formData.userLastName,
      email: formData.isColegial ? colegial.email : formData.userEmail,
      phone: formData.isColegial ? colegial.phone : formData.userPhone,
      totalAmount: cartData.allAmount || 0,
      payMethod: formData.payMethod,
      reference: reference ?? '',
      cardNumber: tiloPayPaymentData.orderNumber,
      cardName:
        formData.payMethod.toUpperCase() === 'TARJETA'
          ? `${tiloPayPaymentData.billToFirstName} ${tiloPayPaymentData.billToLastName}`
          : '',
      observations: formData.generalObservations
    }

    if (formData.isColegial) {
      dataToSend.associatedNumber = formData.nroColegial
    }
    if (formData.proofFile) {
      const formImg = new FormData()

      // Clean filename by removing spaces and special characters
      const originalName = formData.proofFile.name
      const cleanFileName = originalName.replace(/[^a-zA-Z0-9.]/g, '_')

      // Create new File object with clean name
      const cleanFile = new File([formData.proofFile], cleanFileName, {
        type: formData.proofFile.type
      })

      formImg.append('idDocumentCategory', '1')
      formImg.append('idCompany', iDCompany && iDCompany.body.content[0].id)
      formImg.append('files', cleanFile)
      formImg.append('user', 'test')

      try {
        const responseAddImage = await uploadProofMutation.mutateAsync(formImg)
        if (responseAddImage.status === 200) {
          const documentId = responseAddImage?.body?.id
          urlProof = `${UrlBase.app_api}/documents/documents/view/${documentId}?originalName=${cleanFileName}`
        }
      } catch (error) {
        setProofFileError(true)
      }
    }

    dataToSend.bookingDetailList = cartData.allBookings.map((item: any) => ({
      idAreaDetail: item.areaDetailId,
      totalHours: item.totalHours,
      areaAmount: item.areaAmount,
      startTime: item.startDate ? item.startDate : '07:00',
      endTime: item.endDate ? item.endDate : '10:00',
      ...(formData.spaces && { spaces: formData.spaces }),
      status: 2,
      bookingDay: item.bookingDay,
      fullDay: item.totalHours === 0,
      pickUpLocation: formData.pickUp ? formData.pickUp : null,
      dropOffLocation: formData.dropOff ? formData.dropOff : null,
      stops: formData.stops.map((stop: any) => stop.location).join('|'),
      urlProof: urlProof && urlProof
    }))

    try {
      const result = await createBookingMutation.mutateAsync({
        data: dataToSend,
        companyId: iDCompany?.body?.content[0]?.id
      })
      setResponse(result)
      setReserved && setReserved(true)
      document.documentElement.scrollTop = 0
    } catch (error) {
      console.error('Error creating booking:', error)
      setErrorMsg && setErrorMsg('Error al crear la reserva')
    }
  }

  const confirmWithProof = async () => {
    setConfirmModal(false)
    await apiReservation()
  }

  const submitReservations = async () => {
    if (formData.payMethod.toUpperCase() !== 'TARJETA' && formData.proofFile) {
      setConfirmModal(true)
      return
    }
    if (formData.payMethod.toUpperCase() === 'TARJETA') {
      try {
        if (tiloPayPaymentData.url) {
          // Abrir ventana de pago y guardar referencia
          const newWindow = window.open(tiloPayPaymentData.url, '_blank', 'width=800,height=600')
          setPaymentWindow(newWindow)

          // Monitorear cambios en la URL de la ventana de pago
          const checkPaymentStatus = setInterval(async () => {
            try {
              if (newWindow && !newWindow.closed) {
                const currentUrl = newWindow.location.href

                if (currentUrl.includes('/approvePayment')) {
                  clearInterval(checkPaymentStatus)
                  const urlParams = new URLSearchParams(new URL(currentUrl).search)
                  const code = urlParams.get('code')

                  if (code === '1') {
                    // Pago exitoso
                    await apiReservation(tiloPayPaymentData.orderNumber)
                    setOpenModal(false)
                  } else {
                    // Pago fallido
                    setErrorMsg && setErrorMsg('Error al procesar el pago')
                    setOpenModal(false)
                  }
                  newWindow.close()
                }
              }
            } catch (e) {
              // Ignorar errores de acceso cross-origin
            }
          }, 1000)
        }
      } catch (error) {
        console.error('Error processing payment:', error)
        setErrorMsg && setErrorMsg('Error al procesar el pago')
        setOpenModal(false)
      }
    } else {
      await apiReservation()
    }
  }

  const cleanData = () => {
    setCartData(cartDataInit)
    setActiveStep(0)
    setColegial(colegialDataInit)
    queryClient.setQueryData([setFormDataKey], (old: FormData) => formDataInit)
    setReserved && setReserved(false)
  }

  const backAdmin = () => {
    if (formData.area === '') {
      setActiveStep(0)
      setHiddenCart(false)
    } else {
      const oldData = cartData.allBookings
      oldData.splice(-cartData.lastItems)
      setCartData({
        allBookings: oldData
      })
      setActiveStep(2)
    }
  }

  const handleLightbox = (index: number) => {
    setOpenLightbox(true)
    setIndexImg(index)
  }

  const urlImgs = urlImg?.map((img) => ({
    src: img
  }))

  const isLoading = createBookingMutation.isPending || paymentMutation.isPending

  const handleClose = () => {
    setConfirmModal(false)
  }

  return (
    <>
      <Grid container spacing={4}>
        <Grid
          item
          xs={12}
          lg={8}
          sx={{
            borderRight: {
              lg: '1px solid'
            },
            pr: 3,
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {!response ? (
            <>
              <Stack>
                <TextInformation title={`${t('bookingConfirmation')}`} />
                {formData.isColegial ? (
                  <BoxStyled>
                    <Typography fontWeight={'bold'}>{t('nameAndSurname')}:</Typography>
                    <Typography className="textLeft">{colegial.name}</Typography>
                    <Typography fontWeight={'bold'}>{t('email')}:</Typography>
                    <Typography>{colegial.email}</Typography>
                    <Typography fontWeight={'bold'}>{t('phone')}:</Typography>
                    <Typography>{colegial.phone}</Typography>
                  </BoxStyled>
                ) : (
                  <BoxStyled>
                    <Typography fontWeight={'bold'}>{t('name')}:</Typography>
                    <Typography className="textLeft">{formData.userName}</Typography>
                    <Typography fontWeight={'bold'}>{t('lastName')}:</Typography>
                    <Typography>{formData.userLastName}</Typography>
                    <Typography fontWeight={'bold'}>{t('email')}:</Typography>
                    <Typography>{formData.userEmail}</Typography>
                    <Typography fontWeight={'bold'}>{t('phone')}:</Typography>
                    <Typography>{formData.userPhone}</Typography>
                  </BoxStyled>
                )}
                {cartData.allBookings.map((item: any, i: number) => (
                  <DetailSchedules
                    key={i}
                    location={item.areaName}
                    date={dayjs(item.bookingDay).format('DD/MM/YYYY')}
                    initHour={item.startDate}
                    endHour={item.endDate}
                    capacity={formData.spaces}
                    areaType={formData.pickUp ? 'transportation' : ''}
                  />
                ))}
              </Stack>
              {!colegial.BookingAdmin && (
                <>
                  <Stack>
                    {formData.payMethod.toUpperCase() !== 'TARJETA' ? (
                      <BoxStyled>
                        <Typography fontWeight={'bold'}>{t('paymentMethod')}:</Typography>
                        <Typography>{formData.payMethod}</Typography>
                      </BoxStyled>
                    ) : (
                      <BoxStyled>
                        <Typography fontWeight={'bold'}>{t('paymentMethod')}:</Typography>
                        <Typography className="textLeft">{formData.payMethod}</Typography>
                        <Typography fontWeight={'bold'}>{t('cardholderName')}:</Typography>
                        <Typography>
                          {tiloPayPaymentData.billToFirstName +
                            ' ' +
                            tiloPayPaymentData.billToLastName}
                        </Typography>
                        <Typography fontWeight={'bold'}>{t('orderNumber')}:</Typography>
                        <Typography>{tiloPayPaymentData.orderNumber}</Typography>
                      </BoxStyled>
                    )}
                  </Stack>
                  <Divider />
                </>
              )}
              <Stack sx={{ justifyContent: 'center', mt: 3 }}>
                <TotalToPay
                  amount={colegial.BookingAdmin ? 0 : cartData.allAmount}
                  currency={currency}
                />
              </Stack>
            </>
          ) : !isLoading ? (
            <>
              {response.status === 200 ? (
                <>
                  <Typography variant="h5" align="center" mb={4} mt={4}>
                    {response.body.message === 'Reserva exitosa'
                      ? t('bookingInTheApprovalProcess')
                      : t('areaWithoutAvailableSpace')}
                  </Typography>
                  <Box hidden={!response.body.message.includes('exitosa')}>
                    <Typography variant="h6" align="center" sx={{ maxWidth: 800, margin: 'auto' }}>
                      {/* {t('bookingInTheApprovalProcessText')} */}
                      {!proofFileError
                        ? t('bookingPaymentProcessText')
                        : t('bookingPaymentErrorText')}
                    </Typography>
                    <Typography variant="h6" align="center" sx={{ maxWidth: 800, margin: 'auto' }}>
                      {t('youAreIncorporated')}
                    </Typography>
                    <Typography variant="h6" align="center" sx={{ maxWidth: 800, margin: 'auto' }}>
                      {/* {t('sendProof')}{' '} */}
                      {!proofFileError ? t('contactForQuestions') : t('sendProof')}{' '}
                      <Link href={`mailto:${iDCompany?.body?.content[0]?.mail}`}>
                        {iDCompany?.body?.content[0]?.mail}
                      </Link>
                    </Typography>
                  </Box>
                </>
              ) : (
                <Typography
                  variant="h5"
                  align="center"
                  fontWeight={600}
                  color={'error'}
                  mb={4}
                  mt={4}
                >
                  error {response.status}: {response.body.error}
                </Typography>
              )}
            </>
          ) : (
            <Progress />
          )}
          <Stack
            direction={isXs ? 'column-reverse' : 'row'}
            justifyContent={'center'}
            alignItems={'center'}
            spacing={2}
            pb={5}
            pt={2}
          >
            {!response ? (
              <>
                <Button
                  variant="contained"
                  onClick={() => {
                    colegial.BookingAdmin ? backAdmin() : handleBack()
                    setReserved && setReserved(false)
                  }}
                >
                  {t('back')}
                </Button>
                <Button
                  variant="contained"
                  onClick={submitReservations}
                  sx={{ ml: 4 }}
                  data-tdc={formData.payMethod}
                  disabled={isLoading}
                >
                  {t('booking')}
                </Button>
              </>
            ) : response.status === 200 ? (
              <Button variant="contained" onClick={cleanData}>
                {t('makeAnotherBooking')}
              </Button>
            ) : (
              <>
                <Button variant="contained" onClick={cleanData}>
                  {t('makeAnotherBooking')}
                </Button>
                <Button variant="contained" sx={{ ml: 4 }} onClick={submitReservations}>
                  {t('tryAgain')}
                </Button>
              </>
            )}
          </Stack>
        </Grid>
        <Grid
          item
          xs={12}
          lg={4}
          sx={{
            overflow: 'hidden',
            pt: '55px!important',
            pb: '15px',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {!response && (
            <Stack
              sx={{
                maxHeight: {
                  lg: '58vh'
                }
              }}
            >
              {formData.area &&
                (urlImg !== undefined && urlImg?.length > 2 ? (
                  <Swiper
                    spaceBetween={10}
                    slidesPerView={1}
                    navigation
                    mousewheel={true}
                    direction={'horizontal'}
                    modules={[Navigation, Mousewheel]}
                    breakpoints={{
                      425: {
                        slidesPerView: 2,
                        direction: 'horizontal'
                      },
                      600: {
                        slidesPerView: 3,
                        direction: 'horizontal'
                      },
                      1201: {
                        slidesPerView: 3,
                        direction: 'vertical'
                      }
                    }}
                  >
                    {urlImg?.map((img, i) => (
                      <SwiperSlide key={i}>
                        <img alt="name" src={img} onClick={() => handleLightbox(i)} />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                ) : (
                  urlImg?.map((img, i) => (
                    <div key={i}>
                      <img
                        alt="name"
                        height="175px"
                        src={img}
                        onClick={() => handleLightbox(i)}
                        className="img-without-slider"
                      />
                    </div>
                  ))
                ))}
            </Stack>
          )}
        </Grid>
        <LightboxStyled
          open={open}
          index={indexImg}
          close={() => setOpenLightbox(false)}
          slides={urlImgs}
          carousel={{ finite: true }}
          controller={{ closeOnBackdropClick: true }}
        />
        <Dialog open={openModal} fullWidth>
          {responsePayment && responsePayment?.status !== 200 ? (
            <DialogContent>
              <Stack alignItems={'center'} width={'100%'} my={5}>
                <HighlightOff color="error" sx={{ fontSize: 100 }} />
              </Stack>
              <Typography variant="h5" align="center" fontWeight={700} my={2}>
                {t('anErrorProcessingRequest')}
              </Typography>
              {responsePayment.body.errors ? (
                <Typography variant="body1" align="center" mb={3}>
                  {responsePayment.body.errors[0][1]}
                </Typography>
              ) : (
                <Typography variant="body1" align="center" mb={3}>
                  {t('pleaseTryAgainInAFewMinutes')}
                </Typography>
              )}
              <Stack alignItems={'center'} width={'100%'} mt={5} mb={3}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setOpenModal(false)
                    setResultGDataCollector(undefined)
                  }}
                >
                  Cerrar
                </Button>
              </Stack>
            </DialogContent>
          ) : (
            <DialogContent>
              <Typography variant="h5" align="center" fontWeight={700} my={2}>
                {/* Procesando su reserva */}
                {t('processingYourBooking')}
              </Typography>
              <Typography variant="body1" align="center" mb={3}>
                {/* Por favor espere un momento. */}
                {t('pleaseWaitAMoment')}
              </Typography>
              <Progress size={50} padding="20px" />
            </DialogContent>
          )}
        </Dialog>
      </Grid>
      <Dialog open={confirmModal} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>{t('confirmationReceipt')}</DialogTitle>
        <DialogContent>
          <img
            src={formData.proofFile ? URL.createObjectURL(formData.proofFile) : ''}
            alt="Uploaded Proof"
            style={{ maxWidth: '100%' }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            {t('cancel')}
          </Button>
          <Button onClick={confirmWithProof} color="primary">
            {t('booking')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default Confirmation
